import React, {useEffect, useState, useRef} from "react";
import statusService from "../../../services/statusService.js";

const TasksPartialTableFilterBar = ({columns, startDate, endDate, dataUsersOwner,loadContentWithFilters}) => {

    const didFetch = useRef(false);
    const [searchName, setSearchName] = useState("");
    const [searchStatus, setSearchStatus] = useState("");
    const [searchDateIni, setSearchDateIni] = useState();
    const [searchDateEnd, setSearchDateEnd] = useState();
    const [searchCreatedBy, setSearchCreatedBy] = useState("");
    const [dataStatuses, setDataStatus] = useState({});

    const loadStatuses = () => {
        statusService.getStatuses().then(statuses => {
            if (statuses.success) {
                setDataStatus(statuses.data);
            }
        });
    }

    const handleFilter = () => {
        const filter = {
            name: searchName,
            status_id: searchStatus,
            estimated_start: searchDateIni,
            estimated_end: searchDateEnd,
            created_by_user_id: searchCreatedBy,
        }
        loadContentWithFilters(filter, 1)
    };

    useEffect(() => {
        if (!didFetch.current) {
            didFetch.current = true;
            loadStatuses();
        }
        setSearchDateIni(startDate);
        setSearchDateEnd(endDate);
    },[startDate, endDate]);

    return (
        <tr>
            <th></th>
            {columns.map((col) => (
                <th key={col.key} style={{ whiteSpace: "nowrap" }}>
                    {col.key === 'name' ? (
                        <input placeholder="Buscar por nombre" className="form-control" name={col.key} id={col.key} type="text" value={searchName} onChange={(e) => setSearchName(e.target.value)} />
                    ): null}

                    {col.key === 'status_id' ? (
                        <select className="form-control" value={searchStatus} onChange={(e) => setSearchStatus(e.target.value)}>
                            <option value="">- - -</option>
                            {Array.isArray(dataStatuses) &&
                                dataStatuses.map((status) => (
                                    <option key={status.id} value={status.id}>{status.name}</option>
                                ))}
                        </select>
                    ): null}

                    {col.key === 'estimated_start' ? (
                        <input className="form-control" name="start_date" id="start_date" type="date" value={searchDateIni} onChange={(e) => setSearchDateIni(e.target.value)} />
                    ): null}

                    {col.key === 'estimated_end' ? (
                        <input className="form-control" name="end_date" id="end_date" type="date" value={searchDateEnd} onChange={(e) => setSearchDateEnd(e.target.value)}/>
                    ): null}

                    {col.key === 'created_by_user_id' ? (
                        <select className="form-control" value={searchCreatedBy} onChange={(e) => setSearchCreatedBy(e.target.value)}>
                            <option value="">- - -</option>
                            {Array.isArray(dataUsersOwner) &&
                                dataUsersOwner.map((user) => (
                                    <option key={user.id} value={user.id}>{user.name}</option>
                                ))
                            }
                        </select>
                    ): null}
                </th>
            ))}
            <th>
                <button className="btn btn-primary" onClick={() => handleFilter()}>Filtrar</button>
            </th>
        </tr>
    );
}

export default TasksPartialTableFilterBar;